<template>
  <div ref="el">
    <div class="main-question">
      <contenteditable
        tag="p"
        :contenteditable="true"
        v-model="title"
        :noNL="true"
        @input="updateTitle"
      />
    </div>
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";
import contenteditable from "@/components/Contenteditable";

export default {
  name: "AlarmCategory",
  components: { contenteditable },
  mixins: [nodeMixin],
  data() {
    return {
      title: "Categoría de alarma",
    };
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();
    this.title = this.nodeData.data.config?.title || this.title;
    this.updateTitle(this.title);
  },
  methods: {
    updateTitle(value) {
      this.title = value;
      const currentNode = this.$df.getNodeFromId(this.nodeId);
      this.updateNodeData({
        config: { ...(currentNode.data.config || {}), title: value },
      });
    },
  },
};
</script>
